import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightCircleIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CtaButton } from './CtaButton';
import { heroImage, offerSummary } from '../data/offer';
export function Pricing() {
  return <section id="comprar" className="relative w-full overflow-hidden bg-ink-950 py-20 scroll-mt-4" aria-labelledby="oferta" data-id="element-129" data-mp="2jjw7zccunmif">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[380px] w-[760px] -translate-x-1/2 rounded-full bg-brand-red/10 blur-[130px]" aria-hidden="true" data-id="element-130" data-mp="1vujyebdm1cfl" />
      <div className="relative mx-auto max-w-3xl px-5" data-id="element-131" data-mp="25t0s3g3xo55c">
        <h2 id="oferta" className="sr-only" data-id="element-132" data-mp="20teh7dbkv0zp">
          Resumen de la oferta y precio
        </h2>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.5
      }} className="overflow-hidden rounded-3xl border border-white/10 bg-ink-900/90 shadow-[0_40px_100px_-50px_rgba(34,211,238,0.5)]" data-id="element-133" data-mp="3h74lak2p5p9c">
          <img src={heroImage} alt="Todo lo que incluye el paquete 48 Hrs AI Cash Machine" loading="lazy" className="w-full" data-id="element-134" data-mp="4rulvonfomcq" />

          <div className="p-6 sm:p-10" data-id="element-135" data-mp="eqac7pemzrl6">
            <Logo size="md" data-id="element-136" data-mp="ep8wh7moegx4" />

            <ul className="mt-8 divide-y divide-white/10" data-id="element-137" data-mp="3d97d7eknjgo6">
              {offerSummary.map(row => <li key={row.label} className="flex items-start gap-3 py-3.5" data-id="element-138" data-mp="3i7irq2lw6fcq">
                  <ArrowRightCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-cyan" aria-hidden="true" data-id="element-139" data-mp="3n754kaxt5tl0" />
                  <span className="flex-1 text-sm font-semibold text-white" data-id="element-140" data-mp="3rz6evrbf1a8e">{row.label}</span>
                  <span className="text-sm font-semibold text-white/40 line-through" data-id="element-141" data-mp="2ui7lw6popurq">
                    {row.value}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 rounded-2xl border border-white/10 bg-ink-800/70 p-6 text-center" data-id="element-142" data-mp="2rf1sfwj9384o">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-white/50" data-id="element-143" data-mp="2mhi3o2oxfcyh">
                Valor total: <span className="text-white/70" data-id="element-144" data-mp="318qzwunc3wkl">$3,952</span>
              </p>
              <p className="mt-4 text-sm font-semibold uppercase tracking-[0.2em] text-white/50" data-id="element-145" data-mp="2w8wbqyuy1l38">
                Precio exclusivo de hoy
              </p>
              <div className="mt-3 flex items-center justify-center gap-4" data-id="element-146" data-mp="23j5tcdma3x1b">
                <span className="relative font-display text-4xl text-white/40 sm:text-5xl" data-id="element-147" data-mp="23la85qlpuggd">
                  $1,997
                  <span className="absolute left-0 top-1/2 h-[3px] w-full -translate-y-1/2 -rotate-6 bg-brand-red" aria-hidden="true" data-id="element-148" data-mp="2dhd7kop6o0zm" />
                </span>
                <span className="rounded-lg bg-brand-red px-4 py-2 font-display text-4xl text-white sm:text-5xl" data-id="element-149" data-mp="3ox1ujg2ft00f">
                  $27
                </span>
              </div>
              <p className="mt-3 text-sm font-medium text-white/50" data-id="element-150" data-mp="59gna33r9lna">Pago único de hoy</p>

              <CtaButton className="mt-6" data-id="element-151" data-mp="3nf36etg941wg" />

              <div className="mt-4 flex items-center justify-center gap-2 text-xs text-white/40" data-id="element-152" data-mp="3ng4txxegegv2">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-153" data-mp="3rhq255g1m6yx" />
                Pago seguro y encriptado
              </div>
            </div>

            <div className="mt-6 flex flex-col items-center gap-4 rounded-2xl border border-amber-400/30 bg-amber-400/5 p-6 text-center sm:flex-row sm:text-left" data-id="element-154" data-mp="j37rqx2mqfc5">
              <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-full border-2 border-amber-400/70 text-amber-300" data-id="element-155" data-mp="a81skgxv6vil">
                <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-156" data-mp="11zzhnpcofsp6" />
                <span className="mt-0.5 text-[8px] font-bold uppercase tracking-wide" data-id="element-157" data-mp="11xmsos8i4i2m">100%</span>
              </div>
              <p className="text-sm leading-relaxed text-white/70" data-id="element-158" data-mp="3f7ilqb55k2pm">
                Si no quedas completamente satisfecho, te ofrecemos una{' '}
                <span className="font-bold text-brand-red" data-id="element-159" data-mp="3a7nug6hgtb41">garantía de devolución total</span>.{' '}
                <span className="underline" data-id="element-160" data-mp="35a43q73kz5v7">Sin preguntas.</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}